import { render, staticRenderFns } from "./BaseDraggableHand.vue?vue&type=template&id=39d6df0b&"
import script from "./BaseDraggableHand.vue?vue&type=script&lang=js&"
export * from "./BaseDraggableHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports